import { ButtonParticipantMicrophone } from '@/components/ButtonParticipantMicrophone'
import { ButtonParticipantVideo } from '@/components/ButtonParticipantVideo'
import { useSelfMicrophoneButtonState } from '@/hooks/useSelfMicrophoneButtonState'
import { useSelfVideoButtonState } from '@/hooks/useSelfVideoButtonState'
import { useRoomStoreActions } from '@/stores/room'

interface SelfParticipantMicrophoneButtonProps {
  audioMuted: boolean
  participantId: string
  participantName: string
}

const SelfParticipantMicrophoneButton = ({
  audioMuted,
  participantId,
  participantName,
}: SelfParticipantMicrophoneButtonProps) => {
  const { isMicrophoneEnabled, isMicrophoneButtonVisible } =
    useSelfMicrophoneButtonState()
  const { audioMuteHandler } = useRoomStoreActions()

  const handleToggleMute = () => {
    audioMuteHandler(participantId)
  }

  return (
    <ButtonParticipantMicrophone
      audioMuted={audioMuted}
      isMicrophoneButtonVisible={isMicrophoneButtonVisible}
      isMicrophoneEnabled={isMicrophoneEnabled}
      onToggleMute={handleToggleMute}
      participantName={participantName}
    />
  )
}

interface SelfParticipantVideoButtonProps {
  participantId: string
  participantName: string
  videoMuted: boolean
}

const SelfParticipantVideoButton = ({
  participantId,
  participantName,
  videoMuted,
}: SelfParticipantVideoButtonProps) => {
  const { isVideoButtonEnabled, isVideoButtonVisible } =
    useSelfVideoButtonState()
  const { videoMuteHandler } = useRoomStoreActions()

  const handleToggleVideo = () => {
    videoMuteHandler(participantId)
  }

  return (
    <ButtonParticipantVideo
      isVideoButtonVisible={isVideoButtonVisible}
      isVideoEnabled={isVideoButtonEnabled}
      onToggleVideo={handleToggleVideo}
      participantName={participantName}
      videoMuted={videoMuted}
    />
  )
}

interface ParticipantSelfButtonsProps
  extends SelfParticipantMicrophoneButtonProps,
    SelfParticipantVideoButtonProps {}

export const ParticipantSelfButtons = ({
  audioMuted,
  participantId,
  participantName,
  videoMuted,
}: ParticipantSelfButtonsProps) => {
  return (
    <>
      <SelfParticipantMicrophoneButton
        audioMuted={audioMuted}
        participantId={participantId}
        participantName={participantName}
      />
      <SelfParticipantVideoButton
        participantId={participantId}
        participantName={participantName}
        videoMuted={videoMuted}
      />
    </>
  )
}
